import React from 'react';
import { Helmet } from "react-helmet";




class HomeInteriorTags extends React.Component{

  

  render(){

    return(
      <>
        <Helmet>
          <title>Home Interior Designers: Best Home Decor Services - Godrej Interio</title>
          <meta name="description" content="Home Interior Designs from Godrej Interio elevates every corner of your living space. From living rooms to bedrooms, we bring creativity and functionality together seamlessly. Book now!" />
          <link rel="canonical" href={window.location.href} />
          <h1 className='heading-desc'>Home Interior Designs - Godrej Interio</h1>
        </Helmet>
         
      </>
    )
  }

}



export default HomeInteriorTags;
